<template>
  <el-col :span="17" class="footModule">
    <!-- 快捷入口 -->
    <div class="quickAccess">
      <h4 class="title">推荐功能</h4>
      <!-- pop 版 -->
      <ul v-if="!venderType">
        <li class="item" @click="goUrl(0)">
          <img
            src="../../assets/images/home/icon_remake1.png"
            class="icon-x"
            alt=""
          />
          <div class="right">
            <h5>精准营销<img src="@/assets/images/home/tag_new.png" /></h5>
            <span class="desc"
              >150+官方标签，精准人群营销，促进新客首购、老客复购</span
            >
          </div>
        </li>
        <li class="item" @click="goUrl(1)">
          <img
            src="../../assets/images/home/icon_remake2.png"
            class="icon-x"
            alt=""
          />
          <div class="right">
            <h5>订单关怀</h5>
            <span class="desc"
              >催付、催评关怀，提升客户购物体验，提高店铺商品评分</span
            >
          </div>
        </li>
        <li class="item" @click="goUrl(2)">
          <img
            src="../../assets/images/home/icon_remake3.png"
            class="icon-x"
            alt=""
          />
          <div class="right">
            <!-- <h5>指定号码发送</h5> -->
            <h5>上传人群</h5>
            <span class="desc">导入用户PIN上传人群包，定向高效营销</span>
            <!-- <span class="desc">导入/输入私有人群手机号，定向高效营销</span> -->
          </div>
        </li>
        <li class="item" @click="goUrl(3)">
          <img
            src="../../assets/images/home/icon_remake4.png"
            class="icon-x"
            alt=""
          />
          <div class="right">
            <h5>店铺会员<img src="@/assets/images/home/tag_new.png" /></h5>
            <span class="desc"
              >店铺内的会员，包含已购会员+品牌会员或店铺0元开卡会员</span
            >
          </div>
        </li>
        <li class="item" @click="goUrl(4)">
          <img
            src="../../assets/images/home/icon_remake5.png"
            class="icon-x"
            alt=""
          />
          <div class="right">
            <h5>大促偏好人群</h5>
            <span class="desc">关注且偏爱在双11、618等大促期间购物的人群</span>
          </div>
        </li>
        <li class="item" @click="goUrl(5)">
          <img
            src="../../assets/images/home/icon_remake6.png"
            class="icon-x"
            alt=""
          />
          <div class="right">
            <h5>秒杀偏好人群</h5>
            <span class="desc"
              >对偏好秒杀活动的人群进行营销，提高活动转化率</span
            >
          </div>
        </li>
      </ul>
      <!-- 自营版 -->
      <ul v-else>
        <li
          class="item"
          @click="goUrl(item.type)"
          v-for="(item, index) in venderData"
          :key="index"
        >
          <img :src="item.img" class="icon-x" alt="" />
          <div class="right">
            <h5>
              {{ item.title
              }}<img v-if="item.isNew" src="@/assets/images/home/tag_new.png" />
            </h5>
            <span class="desc">{{ item.content }}</span>
          </div>
        </li>
      </ul>
    </div>
  </el-col>
</template>

<script>
export default {
  data() {
    return {
      myChart: null,
      venderData: [
        {
          title: "精准营销",
          isNew: true,
          content:
            "精细化客户营销，100+官方人群标签，促进新客首购，提升老客复购，促进转化成交",
          type: 0,
          img: require("../../assets/images/home/icon_remake1.png"),
        },
        {
          title: "首购有礼",
          isNew: true,
          content:
            "进店第一次消费完成的客户发送关怀短信，赠送礼品，促进二次消费",
          type: 12,
          img: require("../../assets/images/home/icon_remake12.png"),
        },
        {
          title: "复购营销",
          isNew: true,
          content: "当客户多天未成交时，发送一条促销短信，提醒客户进行复购",
          type: 13,
          img: require("../../assets/images/home/icon_remake13.png"),
        },
        {
          title: "客户流失唤醒",
          isNew: true,
          content: "客户超过180天未成交自动关怀客户，唤醒客户记忆",
          type: 14,
          img: require("../../assets/images/home/icon_remake14.png"),
        },
        {
          title: "好评感谢",
          isNew: false,
          content: "买家给出好评后，自动发送感谢短信，建议赠送优惠券",
          type: 15,
          img: require("../../assets/images/home/icon_remake15.png"),
        },
        {
          title: "中差评安抚",
          isNew: false,
          content: "买家给出中差评后，自动匹配模板发送短信给买家，进行安抚",
          type: 16,
          img: require("../../assets/images/home/icon_remake16.png"),
        },
      ],
    };
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
  },
  mounted() {
    // this.drawactivityEcharts();
    // window.addEventListener('resize', () => {
    //     this.myChart.resize();
    // })
  },
  methods: {
    goUrl(type) {
      console.log(this.$store.state.route);
      var url = "",
        index = 0;
      if (type === 0) {
        // 精准营销
        url = "/marketing/marketing/accurate_market";
        index = 3;
      } else if (type === 1) {
        // 订单关怀
        url = "/orderCare/orderCare/expediting";
        index = 2;
      } else if (type === 2) {
        // 指定号码发送
        // url = "/marketing/marketing/designated_send";
        url = "/marketing/marketing/grouping";
        index = 3;
      } else if (type === 3 || type === 4 || type === 5) {
        url = "/manage/manage/grouping";
        index = 1;
      } else if (type == 12) {
        // 首购有礼
        url = "/marketing/auto_marketing/first_purchase";
        index = 3;
      } else if (type == 13) {
        // 复购营销
        url = "/marketing/auto_marketing_official/reminder_purchase_official";
        index = 3;
      } else if (type == 14) {
        // 客户流失唤醒
         url = "/marketing/auto_marketing_official/call_customer_churn";
        index = 3;
      } else if (type == 15) {
        // 好评感谢
        url = "/orderCare/comtCare/thankEvaluationOfficial";
        index = 2;
      } else if (type == 16) {
        // 中差评安抚
        url = "/orderCare/comtCare/poorEvaluationOfficial";
        index = 2;
      }

      // this.bus.$emit("topActive", { index: index, item: this.$store.state.route[index]});
      this.bus.$emit("topHeader", {
        index: index,
        item: this.$store.state.route[index],
      });
      this.$router.push({
        path: url,
      });
    },
    // 会员分布Echarts初始化
    drawactivityEcharts() {
      this.myChart = this.$echarts.init(this.$refs.activityEcharts);
      let options = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        color: ["#7F85E9", "#5882FB", "#FF872F", "#FE4D45", "#4CDFC0"],
        legend: {
          data: [
            "活动（PV）",
            "活动（UV）",
            "参与人次",
            "参与人数",
            "新增人数",
          ],
          textStyle: {
            fontSize: 12,
            color: "#7F85E9",
          },
          y: "bottom",
        },
        grid: {
          y: 10,
          left: "0",
          right: "0",
          bottom: "12%",
          containLabel: true,
        },
        xAxis: {
          // x轴配置
          type: "category",
          boundaryGap: true,
          axisLabel: {
            textStyle: {
              fontSize: 12,
              color: "#999",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["rgba(243, 243, 243, 1)"],
              type: "dashed",
            },
          },
          data: [
            "2019-11-10",
            "2019-11-12",
            "2019-11-14",
            "2019-11-16",
            "2019-11-18",
            "2019-11-20",
            "2019-11-22",
            "2019-11-25",
          ],
        },
        yAxis: {
          // y轴配置
          type: "value",
          boundaryGap: ["10%", "0%"],
          axisLabel: {
            // formatter: '{value} k',
            textStyle: {
              fontSize: 12,
              color: "#999",
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["rgba(243, 243, 243, .8)"],
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "活动（PV）",
            type: "line",
            stack: "总量",
            symbol: "none",
            smooth: true,
            data: [222, 456, 222, 134, 789, 543, 321, 666],
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#7F85E9",
                  width: 1,
                },
                areaStyle: {
                  color: "rgba(127, 133, 233, .2)",
                },
              },
            },
          },
          {
            name: "活动（UV）",
            type: "line",
            stack: "总量",
            symbol: "none",
            smooth: true,
            data: [220, 456, 378, 666, 238, 778, 310, 555],
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#5882FB",
                  width: 1,
                },
                areaStyle: {
                  color: "rgba(88, 130, 251, .2)",
                },
              },
            },
          },
          {
            name: "参与人次",
            type: "line",
            stack: "总量",
            symbol: "none",
            smooth: true,
            data: [1088, 789, 567, 338, 666, 1111, 1288, 1566],
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#FF872F",
                  width: 1,
                },
                areaStyle: {
                  color: "rgba(255, 135, 47, .2)",
                },
              },
            },
          },
          {
            name: "参与人数",
            type: "line",
            stack: "总量",
            symbol: "none",
            smooth: true,
            data: [78, 789, 301, 334, 390, 330, 320, 789],
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#FE4D45",
                  width: 1,
                },
                areaStyle: {
                  color: "rgba(254, 77, 69, .2)",
                },
              },
            },
          },
          {
            name: "新增人数",
            type: "line",
            stack: "总量",
            symbol: "none",
            smooth: true,
            data: [820, 932, 901, 934, 1290, 1330, 1320, 1888],
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#4CDFC0",
                  width: 1,
                },
                areaStyle: {
                  color: "rgba(76, 223, 192, .2)",
                },
              },
            },
          },
        ],
      };
      this.myChart.setOption(options);
    },
  },
};
</script>

<style scoped lang="scss">
.footModule {
  .activityData {
    display: flex;
    flex-direction: column;
    height: 440px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .head {
      flex-shrink: 0;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px 0 25px;
      height: 54px;
      border-bottom: 1px solid #f6f6f6;
      .item.active {
        &::before {
          content: "";
          position: absolute;
          left: 2px;
          bottom: -4px;
          width: 12px;
          height: 2px;
          background-color: #ff536b;
          // box-shadow:0px 2px 3px rgba(255,83,107,0.5);
          // animation: opacity .3s ease-in;
        }
        .txt {
          font-size: 14px;
          color: #333;
          font-weight: bold;
        }
      }
      @keyframes opacity {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
      .left {
        color: #333;
        font-size: 16px;
        font-weight: 800;
      }
      .right {
        display: flex;
        align-items: center;
        .li {
          margin-right: 27px;
          font-size: 14px;
          color: #999;
          font-weight: 400;
          cursor: pointer;
          transition: all 0.2s;
          &:hover {
            color: #fe4d45;
          }
          &:last-child {
            margin: 0;
          }
        }
        .li.active {
          position: relative;
          color: #fe4d45;
          font-weight: bold;
          &::before {
            content: "";
            position: absolute;
            left: 50%;
            bottom: -4px;
            transform: translateX(-50%);
            width: 24px;
            height: 2px;
            background: rgba(254, 77, 69, 1);
            box-shadow: 0px 2px 3px rgba(255, 83, 107, 0.5);
          }
        }
      }
    }
    .activityEchartsBox {
      flex: 1;
      box-sizing: border-box;
      padding: 25px 45px 15px 45px;
    }
  }
  .quickAccess {
    display: flex;
    flex-direction: column;
    height: 300px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .title {
      flex-shrink: 0;
      box-sizing: border-box;
      height: 54px;
      line-height: 52px;
      border-bottom: 1px solid #f6f6f6;
      padding-left: 24px;
      color: #252c38;
      margin-bottom: 20px;
      font-size: 16px;
    }
    ul {
      // flex: 1;
      display: flex;
      flex-flow: wrap;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 24px;
      .item {
        box-sizing: border-box;
        padding: 11px 17px;
        position: relative;
        display: flex;
        width: 33.33%;
        @media screen and (max-width: 1366px) {
          padding: 11px 0 11px 12px;
        }
        margin: 10px 0;
        // height: 100px;
        // box-shadow:0px 0px 12px rgba(0,0,0,0.06);
        border-radius: 4px;
        transition: all 0.1s;
        &:hover {
          box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
          .icon {
            opacity: 1;
          }
        }
        .right {
          margin-left: 16px;
          @media screen and (max-width: 1366px) {
            margin-right: 6px;
          }
          h5 {
            img {
              vertical-align: middle;
              margin-left: 4px;
            }
          }
        }
        cursor: pointer;
        h5 {
          margin: 0 0 6px 0;
          color: #333;
          font-weight: 500;
          font-size: 16px;
        }
        .desc {
          line-height: 20px;
          font-size: 13px;
          color: #999;
        }
        .icon-x {
          // position: absolute;
          // right: 0;
          // bottom: 0;
          width: 60px;
          height: 60px;
          // opacity: .3;
          transition: all 0.2s;
        }
      }
    }
  }
}
</style>